/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Types of vault transactions
 * @export
 */
export const FuelUpVaultTransactionType = {
    deposit: 'deposit',
    withdraw: 'withdraw',
    daily_bonus: 'daily_bonus',
    weekly_bonus: 'weekly_bonus',
    monthly_bonus: 'monthly_bonus',
    evolution_bonus: 'evolution_bonus',
    upgrade_cost: 'upgrade_cost',
    backfill_bonus: 'backfill_bonus'
} as const;
export type FuelUpVaultTransactionType = typeof FuelUpVaultTransactionType[keyof typeof FuelUpVaultTransactionType];


export function instanceOfFuelUpVaultTransactionType(value: any): boolean {
    for (const key in FuelUpVaultTransactionType) {
        if (Object.prototype.hasOwnProperty.call(FuelUpVaultTransactionType, key)) {
            if (FuelUpVaultTransactionType[key as keyof typeof FuelUpVaultTransactionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FuelUpVaultTransactionTypeFromJSON(json: any): FuelUpVaultTransactionType {
    return FuelUpVaultTransactionTypeFromJSONTyped(json, false);
}

export function FuelUpVaultTransactionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpVaultTransactionType {
    return json as FuelUpVaultTransactionType;
}

export function FuelUpVaultTransactionTypeToJSON(value?: FuelUpVaultTransactionType | null): any {
    return value as any;
}

export function FuelUpVaultTransactionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FuelUpVaultTransactionType {
    return value as FuelUpVaultTransactionType;
}

